import { render, staticRenderFns } from "./UpdateBackgroundImage.vue?vue&type=template&id=dc7f939a&"
import script from "./UpdateBackgroundImage.vue?vue&type=script&lang=ts&"
export * from "./UpdateBackgroundImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports